<div class="request">
  <nav class="request__sidebar" aria-label="home-requests">
    <a class="request__back-button" title="Início pedidos" [routerLink]="['/request/solicitation']">
      <i class="icon icon--chevron-left icon--small request__icon-back-button"></i>
      <span class="request__nav-link-span">Início Pedidos</span>
    </a>
  </nav>

  <section class="request__body">
    <app-request-tabs></app-request-tabs>
  </section>
</div>
